import * as React from "react"

const Badge = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m7.363 2.01 4.933.705L13 7.648 6.658 13.99 1.021 8.352 7.363 2.01Zm2.819 4.228a.996.996 0 1 0-1.41-1.409.996.996 0 0 0 1.41 1.41Z" />
  </svg>
)

export default Badge
